module.exports = __webpack_public_path__ + "assets/img/yyindex-6.4b7a2dee.png";